import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import './features/Client/clientApi' // side-effect import: injects clientsApi endpoints into sodApi
import clientCardReducer from './features/Client/clientCardSlice'
import HRListReducer from './features/engagement/HRList/HRListSlice'
import errorsReducer, {
  rtkQueryErrorLogger,
} from '@/features/errors/errors-slice'
import { sodApi } from './services'
import { graphApi } from './services/graphApi'
import userReducer from './features/User/userSlice'
import DeveloperEvidenceReducer from './pages/EngagementDetails/ApplicationDetail/DeveloperEvidence/DeveloperEvidenceSlice'
import AnnotateReducer from './pages/EngagementDetails/ApplicationDetail/Annotation/AnnotateSlice'
import sodReducer from './features/sodAnalysis/SodSlice'
import annotationPollingReducer from './features/annotationPolling/annotationPollingSlice'

export const store = configureStore({
  devTools: process.env.NODE_ENV === 'development',
  reducer: {
    clientCard: clientCardReducer,
    HRList: HRListReducer,
    errors: errorsReducer,
    sodApi: sodApi.reducer,
    graphApi: graphApi.reducer,
    user: userReducer,
    DeveloperEvidence: DeveloperEvidenceReducer,
    Annotate: AnnotateReducer,
    sod: sodReducer,
    annotationPolling: annotationPollingReducer,
  },

  // Additional middleware can be passed to this array
  // Note: clientsApi = sodApi.injectEndpoints(...) — same createApi instance,
  // so only sodApi.middleware needs to be registered (adding clientsApi.middleware
  // too would be a duplicate reference and configureStore throws).
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({serializableCheck:false}).concat(
      sodApi.middleware,
      graphApi.middleware,
      rtkQueryErrorLogger, // put this after other API middleware to catch errors
    ),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

setupListeners(store.dispatch)
